require('angular').module('wowApp.common')
    .factory('ResourceInjector', ['$q', require('./resource-injector-factory')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/resources/index.js
 **/